module.exports = __webpack_public_path__ + "static/who-we-help-work-9818c1fa38fba1e4b96345eb50a67ea1.jpg";